<script lang="ts" setup>
import { computed } from 'vue';
import type { GetProjectDetailsProjectResponse } from '@/api';

const { project } = defineProps<{
  project: GetProjectDetailsProjectResponse;
}>();

const data = computed(() => {
  const header = project.name;
  const subHeader = `${project.address.city.name}, ${project.address.province}`;
  return { header, subHeader, builder: project.builder.name };
});
</script>

<template>
  <section>
    <h1 class="text-xl font-bold tracking-tight text-gray-900 md:text-2xl lg:text-3xl">{{ data.header }}</h1>
    <p class="text-xs text-gray-700 md:text-sm lg:text-base">{{ data.subHeader }}</p>
    <p class="text-xs text-gray-500 md:text-sm">{{ data.builder }}</p>
  </section>
</template>

<style lang="css" scoped></style>
